module.exports = __webpack_public_path__ + "static/img/8114_phase_function_Paper_PointsHejduk_Prediction.cbccce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8114_phase_function_Paper_PointsHejduk_Prediction.png
// module id = SwCS
// module chunks = 0